const button = document.getElementById('associations-button');
const fullscreen =  document.querySelector('.card-fullscreen');
const frame = document.querySelector('.card-preview_frame');
const startIcon =  document.querySelector('.card-preview_frame--preview');
const preview =  document.querySelector('.card-preview_frame--preview');
const scene =  document.querySelector('.card-preview_frame--scene');
const mvp = document.getElementsByName('viewport')[0];
const bottomContent = document.querySelector('.bottom-content');

window.backMode = backMode
document.querySelector('.without-banner').setAttribute("style", 'margin: 20px 15px;')

window.onload = () =>{
    if (document.location.search==="?fullscreen"){
        fullscreenMode()
        if (window.innerWidth < 1030) {
            mvp.setAttribute('content','user-scalable=no,width=1024');
        }
    }
    document.querySelector("header").setAttribute("style", "padding: 0;");
}

function fullscreenMode() {
    frame.setAttribute("style", "z-index: 1061; position: fixed; border: 0; box-shadow: 0; background: white; width: 100vw; height: 100vh; top: 0; left:0; right:0; max-width: 100%;");
    window.history.replaceState(null, null, "?fullscreen");
    Intercom('update', {
        "hide_default_launcher": true
    });

}

function backMode() {
    frame.setAttribute("style", "");
    frame.contentDocument.querySelector('html').setAttribute("style", "");
    preview.setAttribute("style", "");
    scene.setAttribute("style", "");
    mvp.setAttribute('content','width=device-width, initial-scale=1.0');
    window.history.replaceState(null, null, "?");
    Intercom('update', {
        "hide_default_launcher": false
    });
}

function mobileMode() {
    fullscreenMode();
    frame.contentDocument.querySelector('html').setAttribute("style", "height: 890px!important; overflow: scroll!important;");
    preview.setAttribute("style", "display: none;");
    scene.setAttribute("style", "display: none;");
    mvp.setAttribute('content','user-scalable=no,width=1024');
}

if (fullscreen){
    fullscreen.addEventListener('click', ()=>  fullscreenMode())
}

if (startIcon){
    preview.addEventListener('click', ()=>  mobileMode())
}

if (button) {
    const otherLinks = document.querySelectorAll('.link-out-range');
    let isLess = true;

    const showMoreLess = () => {
        if (isLess) {
            isLess = false;
            Object.entries(otherLinks).forEach(([key, tag]) => tag.classList.remove('hidden-link'))
            button.innerHTML = "View less...";
        } else {
            isLess = true;
            Object.entries(otherLinks).forEach(([key, tag]) => tag.classList.add('hidden-link'))
            button.innerHTML = "View more...";
        }
    };
    button.addEventListener('click', showMoreLess)
}